const smartSchool = {
  // Header
  header: {
    title: '智能学校系统',
    backToWebsite: '主网站',
    admin: '管理员',
    systemAdmin: '系统管理员',
    logout: '退出登录',
  },

  // Sidebar
  sidebar: {
    logo: 'SAI学院',
  },

  // Menu Items
  menu: {
    dashboard: '仪表板',

    studentInfo: {
      title: '学生信息',
      details: '学生详情',
      admission: '学生录取',
      onlineAdmission: '在线录取',
      disabled: '残疾学生',
      multiClass: '多班级学生',
      bulkDelete: '批量删除',
      categories: '学生类别',
      house: '学生宿舍',
      disableReason: '禁用原因',
      cv: '学生简历',
      studentDetails: '学生详情',
      manageStudentProfiles: '管理学生档案',
      studentProfile: '学生档案',
      personalInfo: '个人信息',
      contactInfo: '联系信息',
      guardianInfo: '监护人信息',
      academicInfo: '学术信息',
    },

    fees: {
      title: '财务系统',
      collection: '费用收取',
      feeTypes: '费用类型',
      income: '收入',
      expenses: '支出',
      reports: '财务报告',
    },

    onlineCourse: '在线课程',
    behaviourRecords: '行为记录',
    multiBranch: '多分支',

    liveClasses: {
      title: '直播课程',
      gmeet: 'Google Meet',
      zoom: 'Zoom',
    },

    academics: {
      title: '学术',
      calendar: '年度日历',
      lessonPlan: '课程计划',
      subjects: '科目',
      timetable: '时间表',
    },

    examinations: {
      title: '考试',
      regular: '常规考试',
      cbse: 'CBSE考试',
      online: '在线考试',
    },

    attendance: '考勤',
    homework: '作业',

    hr: {
      title: '人力资源',
      employees: '员工',
      departments: '部门',
      leave: '请假管理',
      payroll: '工资单',
      attendance: '员工考勤',
    },

    communicate: {
      title: '沟通',
      notice: '公告栏',
      email: '电子邮件',
      sms: '短信',
    },

    resources: {
      title: '资源',
      downloadCenter: '下载中心',
      library: '图书馆',
      inventory: '库存',
    },

    transport: '交通',
    hostel: '宿舍',
    certificate: '证书',
    frontCMS: '前端CMS',
    alumni: '校友',
    reports: '报告',

    system: {
      title: '系统设置',
      settings: '常规设置',
      backup: '备份',
      roles: '角色与权限',
    },
  },

  // Dashboard
  dashboard: {
    title: '主仪表板',
    subtitle: '智能学校系统综合概览',

    stats: {
      totalStudents: '学生总数',
      activeStudents: '活跃学生',
      newAdmissions: '新录取',
      totalStaff: '员工总数',
      teachers: '教师',
      adminStaff: '行政人员',
      totalRevenue: '总收入',
      pendingFees: '待缴费用',
      collectionRate: '收费率',
      attendanceRate: '出勤率',
      todayPresent: '今日出席',
      todayAbsent: '今日缺席',
      upcomingExams: '即将到来的考试',
      completedExams: '已完成的考试',
      avgScore: '平均分',
      totalClasses: '班级总数',
      activeCourses: '活跃课程',
      totalSubjects: '科目总数',
    },

    quickAccess: {
      title: '快速访问',
      studentAdmission: '新学生录取',
      markAttendance: '标记考勤',
      collectFees: '收取费用',
      createExam: '创建考试',
      assignHomework: '分配作业',
      sendNotice: '发送通知',
      generateReport: '生成报告',
      manageLibrary: '管理图书馆',
    },

    recentActivities: {
      title: '最近活动',
      newStudent: '新学生注册',
      feePayment: '收到费用支付',
      examCreated: '创建新考试',
      homeworkAssigned: '分配作业',
      leaveApproved: '批准请假',
      noticePublished: '发布通知',
      bookIssued: '图书馆借书',
      certificateGenerated: '生成证书',
    },

    upcomingEvents: {
      title: '即将到来的活动',
      parentMeeting: '家长会',
      sportsDay: '运动日',
      examWeek: '考试周',
      holiday: '假期',
      workshop: '研讨会',
    },

    charts: {
      studentGrowth: '学生增长',
      feeCollection: '费用收取',
      attendanceTrend: '出勤趋势',
      examPerformance: '考试表现',
    },
  },

  // Common
  common: {
    search: '搜索',
    allClasses: '所有班级',
    allStatus: '所有状态',
    active: '活跃',
    inactive: '不活跃',
    graduated: '已毕业',
    transferred: '已转学',
    addNew: '添加新',
    totalStudents: '学生总数',
    newThisMonth: '本月新增',
    photo: '照片',
    admissionNo: '录取号',
    studentName: '学生姓名',
    class: '班级',
    rollNo: '学号',
    guardian: '监护人',
    phone: '电话',
    status: '状态',
    actions: '操作',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    close: '关闭',
    confirmDelete: '确认删除',
    deleteWarning: '您确定要删除此记录吗？此操作无法撤消。',
    cancel: '取消',
    email: '电子邮件',
    dateOfBirth: '出生日期',
    gender: '性别',
    male: '男',
    female: '女',
    bloodGroup: '血型',
    religion: '宗教',
    address: '地址',
    guardianName: '监护人姓名',
    guardianPhone: '监护人电话',
    guardianEmail: '监护人邮箱',
    relation: '关系',
    admissionDate: '录取日期',
    category: '类别',
    house: '宿舍',
  },

  // Common Actions
  actions: {
    add: '添加',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    search: '搜索',
    filter: '筛选',
    export: '导出',
    import: '导入',
    print: '打印',
    view: '查看',
    download: '下载',
    upload: '上传',
    submit: '提交',
    approve: '批准',
    reject: '拒绝',
    reset: '重置',
    refresh: '刷新',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '关闭',
    confirm: '确认',
    selectAll: '全选',
    deselectAll: '取消全选',
    bulkAction: '批量操作',
  },

  // Common Labels
  labels: {
    name: '姓名',
    email: '电子邮件',
    phone: '电话',
    address: '地址',
    date: '日期',
    time: '时间',
    status: '状态',
    active: '活跃',
    inactive: '不活跃',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    completed: '已完成',
    inProgress: '进行中',
    description: '描述',
    notes: '备注',
    category: '类别',
    type: '类型',
    amount: '金额',
    total: '总计',
    subtotal: '小计',
    discount: '折扣',
    tax: '税',
    from: '从',
    to: '到',
    startDate: '开始日期',
    endDate: '结束日期',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    createdBy: '创建者',
    updatedBy: '更新者',
  },

  // Messages
  messages: {
    success: '操作成功完成',
    error: '发生错误，请重试',
    deleteConfirm: '您确定要删除吗？',
    noData: '无数据',
    loading: '加载中...',
    saving: '保存中...',
    processing: '处理中...',
    uploadSuccess: '上传成功',
    uploadError: '上传失败',
    invalidData: '无效数据',
    requiredField: '此字段为必填项',
    selectCriteria: '选择搜索条件',
  },

  // Students
  students: {
    title: '学生',
    studentDetails: '学生详情',
    manageStudentProfiles: '管理学生档案',
    totalStudents: '学生总数',
    activeStudents: '活跃学生',
    graduatedStudents: '已毕业学生',
    newThisMonth: '本月新增',
    admissionNo: '录取号',
    studentName: '学生姓名',
    class: '班级',
    section: '部分',
    rollNo: '学号',
    guardian: '监护人',
    phone: '电话',
    email: '电子邮件',
    status: '状态',
    photo: '照片',
    viewDetails: '查看详情',
    studentProfile: '学生档案',
    personalInfo: '个人信息',
    contactInfo: '联系信息',
    guardianInfo: '监护人信息',
    academicInfo: '学术信息',
    dateOfBirth: '出生日期',
    gender: '性别',
    male: '男',
    female: '女',
    bloodGroup: '血型',
    religion: '宗教',
    address: '地址',
    guardianName: '监护人姓名',
    guardianPhone: '监护人电话',
    guardianEmail: '监护人邮箱',
    relation: '关系',
    admissionDate: '录取日期',
    category: '类别',
    house: '宿舍',
    deleteConfirm: '您确定要删除此学生吗？此操作无法撤销。',
    allClasses: '所有班级',
    allStatus: '所有状态',
    active: '活跃',
    inactive: '不活跃',
    graduated: '已毕业',
    transferred: '已转学',
  },

  // Fees
  fees: {
    feeCollection: '费用收取',
    manageFeeCollection: '管理学生费用收取',
    totalCollected: '总收取',
    totalPending: '总待缴',
    totalOverdue: '总逾期',
    totalDiscount: '总折扣',
    yemeniRial: '也门里亚尔',
    allClasses: '所有班级',
    allStatus: '所有状态',
    paid: '已付',
    partial: '部分付款',
    pending: '待缴',
    overdue: '逾期',
    feeType: '费用类型',
    amount: '金额',
    due: '应付',
    dueDate: '到期日',
    recordPayment: '记录付款',
    viewReceipt: '查看收据',
    feeTypes: '费用类型',
    manageFeeTypes: '管理学术费用类型',
    addFeeType: '添加费用类型',
    code: '代码',
    feeName: '费用名称',
    feeGroup: '费用组',
    description: '描述',
    allGroups: '所有组',
    active: '活跃',
    inactive: '不活跃',
    deleteFeeTypeConfirm: '您确定要删除此费用类型吗？',
  },

  // Income
  income: {
    title: '收入',
    manageIncome: '管理收入记录',
    totalIncome: '总收入',
    totalRecords: '总记录',
    averageIncome: '平均收入',
    records: '记录',
    incomeRecords: '收入记录',
    addIncome: '添加收入',
    date: '日期',
    invoiceNo: '发票号',
    category: '类别',
    description: '描述',
    amount: '金额',
    paymentMethod: '付款方式',
    receivedBy: '接收人',
    allCategories: '所有类别',
    dateFrom: '开始日期',
    dateTo: '结束日期',
    deleteConfirm: '您确定要删除此收入记录吗？',
  },

  // Expenses
  expenses: {
    title: '支出',
    manageExpenses: '管理支出记录',
    totalExpenses: '总支出',
    totalRecords: '总记录',
    averageExpense: '平均支出',
    records: '记录',
    expenseRecords: '支出记录',
    addExpense: '添加支出',
    date: '日期',
    invoiceNo: '发票号',
    category: '类别',
    description: '描述',
    amount: '金额',
    paymentMethod: '付款方式',
    paidTo: '支付给',
    vendor: '供应商',
    status: '状态',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    allCategories: '所有类别',
    allStatus: '所有状态',
    dateFrom: '开始日期',
    dateTo: '结束日期',
    deleteConfirm: '您确定要删除此支出记录吗？',
    approveExpense: '批准支出',
    rejectExpense: '拒绝支出',
  },

  // Financial Reports
  financialReports: {
    title: '财务报告',
    subtitle: '财务报告和分析',
    revenueVsExpenses: '收入与支出',
    profitLoss: '损益',
    feeCollectionRate: '费用收取率',
    outstandingFees: '未付费用',
    totalRevenue: '总收入',
    totalExpenses: '总支出',
    netProfit: '净利润',
    netLoss: '净亏损',
    collectionRate: '收取率',
    outstanding: '未付',
    monthlyRevenue: '月收入',
    monthlyExpenses: '月支出',
    selectPeriod: '选择期间',
    thisMonth: '本月',
    lastMonth: '上月',
    thisYear: '今年',
    lastYear: '去年',
    custom: '自定义',
    generateReport: '生成报告',
    profitLossStatement: '损益表',
    period: '期间',
    revenue: '收入',
    expenses: '支出',
    profit: '利润',
    loss: '亏损',
  },
};

export default smartSchool;